<template>
  <div
    class="ms-label flex items-center"
    :style="getStyle"
    v-bind="$attrs"
  >
    <ms-icon
      v-if="icon"
      :icon="icon"
      class="m-r-8"
      :style="iconStyle"
      @click="$emit('icon-click');"
    />
    <slot />
  </div>
</template>
<script>
export default {
  name: "MsLable",
  props: {
    icon: {
      type: [String, Boolean],
      default: true
    },
    iconBg: {
      type: [String],
      default: "transparent"
    },
    bg: {
      type: [String],
      default: "transparent"
    },
    color: {
      type: [String],
      default: "#000000"
    }
  },
  computed: {
    getStyle() {
      return {
        background: this.bg,
        color: this.color
      };
    },
    iconStyle() {
      return {
        backgroundColor: this.iconBg + ' !important'
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.ms-label {
  height: 100%;
}
</style>